<template>
  <section class="Counter">
    <div class="Counter-tline"></div>
    <div class="Counter-bline" ref="bline"></div>
    <header class="CounterHead" ref="header">
      <h1 ref="title">
        2020 : <span class="CounterValue" ref="value">{{ counterValue }}</span> féminicides
      </h1>
      <div class="CounterHead-bg" ref="headerbg"></div>
    </header>
    <div class="Counter-names" ref="wrapper">
      <ul ref="list">
        <li v-for="(w,i) in women" :key="i">
          {{ w.name }}
        </li>
      </ul>
      <ul ref="listclone" class="clone">
        <li v-for="(w,i) in women" :key="i">
          {{ w.name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
// import CounterNumber from '@/components/CounterNumber'
import gsap from 'gsap'

export default {
  components: {
    // CounterNumber
  },
  props: {
    women: Array
  },
  data () {
    return {
      isShown: false,
      numbers: 0,
      timeline: null,
      duration: 0,
      counterValue: '',
      counterValueClone: ''
    }
  },
  watch: {
    women: function (newVal, oldVal) {
      if (newVal.length && newVal.length > 0) {
        this.duration = 3 * newVal.length
        this.counterValue = newVal.length
        this.counterValueClone = newVal.length
      }
    }
  },
  updated () {
    if (this.isShown) return
    if (this.women.length > 0) {
      this.show(this.women.length)
      this.animateList(this.women.length)
    }
  },
  mounted () {
  },
  beforeDestroy () {
    if (this.timeline) this.timeline.kill()
  },
  methods: {
    animateList (length) {
      const time = this.duration
      if (this.$refs.length <= 0) return
      if (this.timeline) this.timeline.kill()

      this.timeline = gsap.timeline({ repeat: -1 })
      this.timeline
        .fromTo(this.$refs.list, time, { rotation: 0.01, xPercent: 0 }, { force3D: true, xPercent: -100, ease: 'none' }, 0)
        .fromTo(this.$refs.listclone, time, { rotation: 0.01, xPercent: 100 }, { force3D: true, xPercent: 0, ease: 'none' }, 0)
        .set(this.$refs.list, { force3D: true, rotation: 0.01, xPercent: 100 })
        .to(this.$refs.listclone, time, { force3D: true, rotation: 0.01, xPercent: -100, ease: 'none' }, time)
        .to(this.$refs.list, time, { force3D: true, rotation: 0.01, xPercent: 0, ease: 'none' }, time)
    },
    show (womenCount) {
      this.isShown = true
      // setTimeout(() => {
      //   console.log(this.$refs.titleclone.offsetWidth)
      // }, 1000)

      if (this.tlShow) this.tlShow.kill()
      // console.log(this.$refs.header.offsetWidth)
      const tweenValue = {
        figure: 0
      }
      this.tlShow = gsap.timeline({
        defaults: { duration: 0.6 },
        onComplete: () => {
          this.animateList(womenCount)
        }
      })
      // console.log(this.$refs.title.offsetWidth + (10 * womenCount.toString().length))
      const bgw = this.$refs.title.offsetWidth
      this.tlShow.fromTo(this.$refs.headerbg, { x: window.innerWidth }, { x: 0, ease: 'expo.out' }, 0)
      this.tlShow.to(this.$refs.headerbg, { width: bgw, ease: 'expo.out' }, 0.6)
      this.tlShow.to(this.$refs.title, { alpha: 1, ease: 'expo.out' }, 0.4)
      const dw = 0.05 * womenCount
      this.tlShow.fromTo(tweenValue, { figure: 0 }, {
        duration: dw,
        figure: womenCount,
        onUpdate: () => {
          this.counterValue = Math.floor(tweenValue.figure)
          this.$refs.value.style.color = 'red'
        },
        onComplete: () => {
          // this.$refs.value.style.color = 'black'
          this.$refs.headerbg.style.transition = 'width 200ms linear'
          // this.$refs.headerbg.style.width = '100%'
        }
      }, 0.8)

      this.tlShow.fromTo(this.$refs.bline, { duration: dw, scaleX: 0, scaleY: 2 }, { scaleX: 1, ease: 'linear' }, 0.8)
      this.tlShow.fromTo(this.$refs.bline, { duration: 0.4, background: 'white' }, { background: 'red', ease: 'expo.out' }, 0.7)
      this.tlShow.to(this.$refs.bline, { scaleX: 1, scaleY: 1, background: 'white' }, 1.4 + dw)
      this.tlShow.to(this.$refs.wrapper, { alpha: 1, ease: 'expo.out' }, 1.2)
      this.tlShow.set(this.$refs.header, { background: 'white' }, 1.2)
    }
  }
}
</script>

<style lang="stylus">
dark-color = #1b1b1b

.Counter
  position relative
  z-index 100
  color white
  text-align left
  // border-bottom 1px solid white
  display flex
  &-bline
    position absolute
    z-index 3
    background white
    width 100%
    height 1px
    bottom 0
    transform-origin left center
    transform scale(0)
  .CounterHead
    display flex
    align-items center
    white-space nowrap
    // width 241px
    color dark-color
    font-family LeagueMonoBold
    text-transform uppercase
    h1
      padding 12px 20px
      position relative
      z-index 2
      opacity 0
    &-bg
      position absolute
      z-index 1
      background rgba(255, 255, 255, 1)
      width 100%
      height 100%
      top 0
      left 0
      transform translate(100vw, 0)
      // transition width 200ms linear

    // .title-clone
    //   position absolute
    //   pointer-events none
    //   visibility hidden

  &-names
    width calc(100% - 200px)
    overflow hidden
    position relative
    // display flex
    // flex-wrap nowrap
    opacity 0
  ul
    display flex
    flex-wrap nowrap
    position absolute
    top 0
    left 0
    z-index 2
    &.clone
      z-index 1
    li
      padding 12px 20px
      white-space nowrap
      border-left 1px solid white
      background dark-color
      color white
  

// @media(max-width: 1024px)
//   .Counter
//     .CounterHead

@media(max-width: 600px)
  .Counter
    left 0
    top 0
    font-size 0.8rem
    .CounterHead
      width auto
      h1
        padding 8px 10px
    &-names
      width 100%
    ul
      li
        padding 8px 10px

@media(max-width: 320px)
  .Counter
    left 0
    top 0

@media screen and (max-width:670px) and (orientation:landscape)
  .Counter
    display none
</style>
